import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  AutoSavedTagsInputControl,
  Card,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';

export interface CampaignIdParamsProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  validation: FormValidator
  t: (key: string) => string
}

export class CampaignIdParams extends React.Component<CampaignIdParamsProps> {
  constructor(props: CampaignIdParamsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        Object.keys(values)[0],
        (settings.attributes as any)[Object.keys(values)[0]],
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, t, validation } = this.props;

    return (
      <Card.Section>
        <AutoSavedTagsInputControl
          id="tracker-settings-campaign-id-params"
          label={t('apps.details.settings.campaignIdParams.title')}
          info={t('components:tagsInput.placeholder.default')}
          name="campaign_id_params"
          initialValue={settings.attributes.campaign_id_params}
          validationSchema={validation.createValidationSchema(
            (validators: any) => ({
              campaign_id_params: validators.trackerSettings.campaignIdParams,
            }),
          )}
          onSubmit={this.handleSubmit}
        />
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(withTranslation(['administration'])(CampaignIdParams as any));
